import { render, staticRenderFns } from "./DownloadOkSVG.vue?vue&type=template&id=00f5cb0e&"
import script from "./DownloadOkSVG.vue?vue&type=script&lang=js&"
export * from "./DownloadOkSVG.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports